import SmiV2YouTube from './smiV2YouTube';
import SmiV2Instagram from './smiV2Instagram';
import SmiV2Twitter from './smiV2Twitter';
import SmiV3Instagram from './smiV3Instagram';


export default class SMIV2 {
  constructor({ apiUrl, whitelisted }) {
    this.youtube = new SmiV2YouTube({
      serviceName: 'youtube',
      smiv2endpoint: apiUrl,
    });

    if (whitelisted) {
      this.instagram = new SmiV3Instagram({
        serviceName: 'instagram',
        smiv2endpoint: apiUrl,
      });
    } else {
      this.instagram = new SmiV2Instagram({
        serviceName: 'instagram',
        smiv2endpoint: apiUrl,
      });
    }

    this.twitter = new SmiV2Twitter({
      serviceName: 'twitter',
      smiv2endpoint: apiUrl,
    });
  }
}
